const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

const asValidDate = (date: Date): Date | null => (Number.isNaN(date.getTime()) ? null : date);

/** The API uses `'-'` for "no date". */
const isBlank = (value: string | number | null | undefined): value is null | undefined | '-' =>
  !value || value === '-';

const datePart = (value: string): string => (value.includes('T') ? value.slice(0, 10) : value);

export const parseDateForPicker = (value: string | number | null | undefined): Date | null => {
  if (isBlank(value)) {
    return null;
  }

  if (typeof value === 'number') {
    return asValidDate(new Date(value * 1000));
  }

  const dateOnly = datePart(value);

  if (ISO_DATE.test(dateOnly)) {
    const [year = 0, month = 1, day = 1] = dateOnly.split('-').map(Number);
    const parsed = new Date(year, month - 1, day);

    return parsed.getMonth() === month - 1 && parsed.getDate() === day ? parsed : null;
  }

  return asValidDate(new Date(value));
};

const pad = (n: number): string => String(n).padStart(2, '0');

/** An ISO instant stays as is; a number below 1e12 is epoch seconds, otherwise milliseconds. */
export const normalizeInstant = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number') {
    const date = new Date(value < 1_000_000_000_000 ? value * 1000 : value);
    return Number.isNaN(date.getTime()) ? '' : date.toISOString();
  }

  return value;
};

export const formatDateForInput = (value: string | number | null): string => {
  if (isBlank(value)) {
    return '';
  }

  if (typeof value === 'number') {
    return new Date(value * 1000).toISOString().slice(0, 10);
  }

  return datePart(value);
};

export const formatDateForRequest = (value: Date | null | undefined): string => {
  if (!value || Number.isNaN(value.getTime())) {
    return '';
  }

  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
};
